var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarbonNeutral = function SvgCarbonNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "carbon-neutral_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#carbon-neutral_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.587 0c8.907.456 14.326 10.238 9.747 18.054-4.52 7.72-15.669 7.912-20.452.348C-3.02 10.657 2.302.432 11.412 0h1.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.172 9.878c-.42-2.397-2.086-4.52-4.172-5.694-2.613 1.486-4.46 4.351-4.268 7.432.132 2.17 1.775 3.909 3.932 4.124v3.177l.048.048h.624V15.74c1.822-.191 3.38-1.486 3.812-3.284.192-.804.168-1.775.024-2.59v.012Zm-2.841 2.158.491.384-1.498 1.81v1.486a1.618 1.618 0 0 1-.636 0v-2.685l-1.786-1.523c0-.023.3-.395.336-.42.024-.023.048-.035.084-.023l1.366 1.115v-2.026l-1.462-1.187c0-.024.3-.42.323-.444.024-.023.048-.035.084-.023l1.055.827V7.744h.588l.048.048v2.89L13.33 9.47l.491.383-1.498 1.81v1.57l1.007-1.21v.012Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "carbon-neutral_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgCarbonNeutral as ReactComponent };